import Cookies from 'universal-cookie';

const init = {};
const SHOWED_PROMO = 'SHOWED_PROMO';

export default function(state = init, action = {}) {
  switch (action.type) {
    case SHOWED_PROMO:
      return { ...state, promo: null };
    default:
      return state;
  }
}

export function showedPromo() {
  return dispatch => {
    const cookies = new Cookies();
    cookies.remove('promo', { path: '/' });
    dispatch({ type: SHOWED_PROMO });
  };
}



// WEBPACK FOOTER //
// ./shared/components/link/actions.js